module.exports = __webpack_public_path__ + "static/media/skip.c982bc1e.m4a";